<template>
  <footer id="footer" class="footer">
    <div class="copyright">
      &copy; Copyright <span><strong>FinPlan</strong> {{ year }}</span>.
    </div>

  </footer>
</template>

<script setup>
import {computed} from "vue";

const year = computed(() => {
  return new Date().getFullYear();
});
</script>
